import React from 'react';

const SEND_MESSAGE_ICON_PATH =
  'M240,127.89a16,16,0,0,1-8.18,14L63.9,237.9A16.15,16.15,0,0,1,56,240a16,16,0,0,1-15-21.33l27-79.95A4,4,0,0,1,71.72,136H144a8,8,0,0,0,8-8.53,8.19,8.19,0,0,0-8.26-7.47h-72a4,4,0,0,1-3.79-2.72l-27-79.94A16,16,0,0,1,63.84,18.07l168,95.89A16,16,0,0,1,240,127.89Z';

export function SendMessageButton({ className, disabledClassName, disabled = false, onClick, tabIndex }) {
  const buttonClassName = [className, disabled ? disabledClassName : null].filter(Boolean).join(' ');

  return (
    <button
      type='button'
      className={buttonClassName}
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabIndex}
      aria-label='Send message'
    >
      <svg
        width='17'
        height='17'
        viewBox='0 0 256 256'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
      >
        <path d={SEND_MESSAGE_ICON_PATH} />
      </svg>
    </button>
  );
}
